module.exports = __webpack_public_path__ + "static/media/time2.471a0b60.svg";